import { hasConsent } from '@squareup/service-one-trust';
export function writeString(key, value, consent) {
    if (window?.localStorage && hasConsent(consent)) {
        window?.localStorage.setItem(key, value);
        return true;
    }
    return false;
}
export function writeObject(key, value, consent) {
    const jsonString = JSON.stringify(value);
    return writeString(key, jsonString, consent);
}
export function readString(key, consent) {
    if (window?.localStorage && hasConsent(consent)) {
        const value = window?.localStorage.getItem(key) ?? undefined;
        return {
            value,
            success: true,
        };
    }
    return { success: false };
}
export function readObject(key, consent) {
    const { success, value } = readString(key, consent);
    if (success) {
        const returnValue = value ? JSON.parse(value) : undefined;
        return {
            value: returnValue,
            success: true,
        };
    }
    return {
        success: false,
    };
}
export {};
